module.exports = __webpack_public_path__ + "img/map2880.b8ba50f8.png";